import * as React from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";
import DetailsPage from "../pages/customer/details";
import { RequireAuthCustomer, RequireAuthQuote } from "./components/required-auth.component";
import FAQSView from "../pages/customer/faq";
import NotFoundPage from "../pages/errors/404";
import { AuthProvider } from "../context/AuthContext.component";
import * as webHelpers from "../helpers/WebHelpers";
import QuoteOverviewPage from "../pages/quote/overview";
import QuoteBookingPage from "../pages/quote/booking";
import { Dashboard } from "../pages/customer/overview";
import CapturePage from "../pages/customer/capture";
import { SignInFormCustomer } from "../pages/customer/signin";
import { SignInFormQuote } from "../pages/quote/signin";
import { Privacy } from "../pages/customer/privacy";
import { InvoiceConfirmation } from "../pages/customer/overview/components/InvoiceConfirmation";

export function PageRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={
          <Navigate to="/customer/signin"/>
        } />

        <Route path="/customer" element={
          <Navigate to="/customer/signin"/>
        } />

        <Route path="/customer/signin/:jobNumber" element={<SignInFormCustomer />} />

        <Route path="/customer/signin" element={<SignInFormCustomer />} />

        <Route
          path="/customers/home/signin" element={<Navigate to="/customer/signin" replace/>}
        />

        <Route
          path="/customer/overview/:jobNumber"
          element={
            <RequireAuthCustomer>
              <Dashboard />
            </RequireAuthCustomer>
          }
        />

        <Route
          path="/customer/capture/:jobNumber"
          element={
            <RequireAuthCustomer>
              <CapturePage />
            </RequireAuthCustomer>
          }
        />

        <Route
          path="/customer/details/:jobNumber"
          element={
            <RequireAuthCustomer>
              <DetailsPage />
            </RequireAuthCustomer>
          }
        />

        {/* <Route
          path="/customer/invoice/:jobNumber"
          element={
            <RequireAuthCustomer>
              <InvoiceConfirmation/>
            </RequireAuthCustomer>
          }
        /> */}

        <Route
          path='/customer/privacy'
          element={
            <Privacy />
          }
        />

        <Route 
          path={'/customer/faqs'}
          element={
            <FAQSView />
          }
        />

        <Route
          path="/customer/signout"
          element={
            <SignOutCustomer />
          }
        />

        <Route path="/quote" element={
          <Navigate to="/quote/signin"/>
        } />

        <Route path="/quote/signin/:quoteId" element={<SignInFormQuote />} />

        <Route path="/quote/signin" element={<SignInFormQuote />} />

        <Route
          path="/quotes/:quoteId"
          element={ <ReDirectQuote/> }
        />

        <Route
          path="/quote/overview/:quoteId"
          element={
            <RequireAuthQuote>
              <QuoteOverviewPage />
            </RequireAuthQuote>
          }
        />

        <Route
          path="/quote/booking/:quoteId"
          element={
            <RequireAuthQuote>
              <QuoteBookingPage />
            </RequireAuthQuote>
          }
        />

        <Route
          path="/quote/signout"
          element={
            <SignOutQuote />
          }
        />

        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </AuthProvider>
  );
}

function ReDirectQuote() {
  const { quoteId } = useParams();
  let route: string = "/quote/signin/" + quoteId;

  return <Navigate replace to={route}/>
}

function SignOutCustomer() {
  React.useEffect(() => {
    webHelpers.postAsync("/api/signout", {});
  }, []);

  return <Navigate to="/customer/signin" replace />
}

function SignOutQuote() {
  React.useEffect(() => {
    webHelpers.postAsync("/api/signout", {});
  }, []);

  return <Navigate to="/quote/signin" replace />
}